import type { IFinanceRateInfo } from '../types';

export function createCreditRateOptions(rate: IFinanceRateInfo) {
  switch (rate.type) {
    case 'Excellent':
      return (
        <option value="0" key="credit-rate-value-0">
          Excellent ({rate.minimumFicoScore}+ FICO® Score)
        </option>
      );
    case 'VeryGood':
      return (
        <option value="1" key="downpayment-options-value-1">
          Very Good ({rate.minimumFicoScore}-{rate.maximumFicoScore} FICO®
          Score)
        </option>
      );
    case 'Good':
      return (
        <option value="2" key="downpayment-options-value-2">
          Good ({rate.minimumFicoScore}-{rate.maximumFicoScore} FICO® Score)
        </option>
      );
    case 'Fair':
      return (
        <option value="3" key="downpayment-options-value-3">
          Fair ({rate.minimumFicoScore}-{rate.maximumFicoScore} FICO® Score)
        </option>
      );
    case 'Challenged':
      return (
        <option value="4" key="downpayment-options-value-4">
          Challenged (&lt;{' '}
          {rate.maximumFicoScore ? rate.maximumFicoScore + 1 : ''} FICO® Score)
        </option>
      );
  }
}
